import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Form, Spinner } from 'react-bootstrap';

import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import moment from 'moment/moment';
import logger from 'util/logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { actionGetDashboardStats } from 'stores/dashboard';
import { getDashboardBarOptions } from './dashboardChartOptions';
import {
  getReportSliceDate,
  getReportSliceFeesCollected
} from './dashboardReportData';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

const NotaryMonthlyFee = ({ months }) => {
  logger.log('TotalSales months', months);
  const [month, setMonth] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const setChartsData = () => {
    if (month) {
      //logger.log('notayFeeMonthly data loaded', notayFeeMonthly);
      let startDate = moment(month).startOf('month').format('YYYY-MM-DD');
      let endDate = moment(month).endOf('month').format('YYYY-MM-DD HH:mm:ss');

      // let filterData = _.filter(notayFeeMonthly, (s) => {
      //   return moment(moment(s.date).format('YYYY-MM-DD')).isBetween(startDate, endDate);
      // });
      // setData(filterData);
      setLoading(true);
      dispatch(actionGetDashboardStats(startDate, endDate))
        .then(res => {
          setLoading(false);
          let Slices = _.get(res, 'Slices');
          logger.log('Slices data for graph', Slices);
          let signingData = [];
          _.map(Slices, slice => {
            signingData.push({
              date: getReportSliceDate(slice),
              fee: getReportSliceFeesCollected(slice)
            });
          });
          //setSigning(signingData);

          const periodStart = moment(startDate).startOf('day');
          const periodEnd = moment(endDate).endOf('day');
          let filterData = signingData
            ? _.filter(signingData, s => {
                logger.log('Signing dates', s.date);
                return moment(s.date).isBetween(
                  periodStart,
                  periodEnd,
                  undefined,
                  '[]'
                );
              })
            : [];
          logger.log('filterData', filterData);
          setData(filterData);
        })
        .catch(err => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (month === '') {
      setMonth(moment().startOf('month').format('YYYY-MM-DD'));
    }
  }, []);

  useEffect(() => {
    setChartsData();
  }, [month]);

  // useEffect(() => {
  //   if (month === '') {
  //     setMonth(moment().startOf('month').format('YYYY-MM-DD'));
  //   }
  //   if (rawData) {
  //     logger.log('rawData', rawData);
  //     let Slices = _.get(rawData, 'Slices');
  //     logger.log('Slices data for graph', Slices);
  //     let signingData = [];
  //     _.map(Slices, slice => {
  //       signingData.push({
  //         date: moment(slice.End).format('YYYY-MM-DD'),
  //         fee: slice.FeesCollected
  //       });
  //     });
  //     setNotayFeeMonthly(signingData);
  //   }
  // }, [rawData]);

  const feesTotal = _.sumBy(data, 'fee');
  const formattedFeesTotal = `$${Number(feesTotal || 0).toLocaleString(
    undefined,
    {
      maximumFractionDigits: 2
    }
  )}`;

  return (
    <Card className="h-100 d-flex flex-column" style={{ minHeight: '32rem' }}>
      <FalconCardHeader
        title="Notarization Fees over Time"
        titleTag="h6"
        className="pb-0"
        endEl={
          <Flex>
            <Form.Select
              size="sm"
              value={month}
              onChange={e => setMonth(e.target.value)}
              className="me-2"
            >
              {months &&
                months.map((i, index) => (
                  <option value={i.begin} key={i.begin}>
                    {i.title}
                  </option>
                ))}
            </Form.Select>
            {/* <CardDropdown /> */}
          </Flex>
        }
      />

      <Card.Body className="pt-1 d-flex flex-column flex-grow-1">
        <div className="mb-2 flex-shrink-0">
          <p className="text-600 fs--1 mb-0">
            {formattedFeesTotal} in fees assessed in the displayed period
          </p>
        </div>
        <div
          className="position-relative flex-grow-1 w-100"
          style={{ flexBasis: 0, minHeight: '26rem' }}
        >
          {!loading && months && (
            <ReactEChartsCore
              className="h-100"
              echarts={echarts}
              option={getDashboardBarOptions({
                data: _.map(data, 'fee'),
                keys: data.map(function (obj, index) {
                  return moment(obj.date).format('MMM D');
                }),
                xAxisLabel: 'Date',
                xAxisLabelRotate: 90,
                yAxisLabel: 'Fees ($)',
                valuePrefix: '$',
                compactYAxisLabels: true
              })}
              style={{ width: '100%', height: '100%' }}
            />
          )}
          {loading && (
            <Flex
              justifyContent={'center'}
              alignItems={'center'}
              className="position-absolute top-0 start-0 w-100 h-100"
            >
              <Spinner />
            </Flex>
          )}
          {data.length == 0 && !loading && (
            <Flex
              justifyContent={'center'}
              alignItems={'center'}
              direction={'column'}
              className="position-absolute top-0 start-0 w-100 h-100 text-600 fs--1"
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              <p className="mb-0">No fees for this period</p>
            </Flex>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

NotaryMonthlyFee.propTypes = {
  months: PropTypes.array.isRequired,
  loading: PropTypes.bool
};

export default NotaryMonthlyFee;
